import DatabaseSearch from "./DatabaseSearch.vue";

export default [
    {
        id: "database-search",
        label: "Database Search",
        component: DatabaseSearch,
    },
];
